import { createFileRoute } from "@tanstack/react-router"
import { childrenQueryOptions } from "@/features/children/api/children.queries"
import { getSelectedChildId } from "@/features/children/useSelectedChild"
import { statisticsQueryOptions } from "@/features/statistics/api/statistics.queries"
import { StatisticsPage } from "@/features/statistics/StatisticsPage"
import {
  DEFAULT_RANGE,
  isRange,
  type StatisticsRange,
} from "@/features/statistics/statistics.config"

export const Route = createFileRoute("/_app/statistik")({
  validateSearch: (search: Record<string, unknown>): { range: StatisticsRange } => ({
    range: isRange(search.range) ? search.range : DEFAULT_RANGE,
  }),
  loaderDeps: ({ search }) => ({ range: search.range }),
  loader: async ({ context, deps }) => {
    const children = await context.queryClient.ensureQueryData(childrenQueryOptions)
    const childId = getSelectedChildId(children)
    if (childId) {
      await context.queryClient.ensureQueryData(statisticsQueryOptions(childId, deps.range))
    }
  },
  component: StatisticsPage,
})
